import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}

@media print {
  :host {
    height: auto !important;
    overflow: visible !important;
    display: block !important;
  }
  :host ::ng-deep > div {
    height: auto !important;
    overflow: visible !important;
    display: block !important;
    flex: none !important;
  }
  :host ::ng-deep > div > div {
    height: auto !important;
    overflow: visible !important;
    flex: none !important;
    min-height: auto !important;
  }
}`],
})
export class LayoutSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/access')) return;
    }
}

export default LayoutSidebarComponent;